/* IRIS product page — Stitched / Unstitched → Size gating.
   When "Unstitched" is selected, the Size option group fades and locks
   (unstitched fabric has no size); a valid size is auto-selected behind the
   scenes so a real variant still resolves. When "Stitched" is selected, Size
   unlocks. Detection is by option VALUE ("stitched"/"unstitched", sizes), so
   it keeps working regardless of the option's label. Delegated + observed so
   it survives Dawn re-rendering the picker on variant change. */
(function () {
  if (window.__irisStitchInit) return;
  window.__irisStitchInit = true;

  function norm(s) { return (s || '').trim().toLowerCase(); }

  function fieldsets(root) {
    return root.querySelectorAll('fieldset.product-form__input, .product-form__input');
  }

  function valuesOf(fs) {
    var out = [];
    fs.querySelectorAll('input[type="radio"]').forEach(function (i) { out.push(norm(i.value)); });
    if (!out.length) fs.querySelectorAll('option').forEach(function (o) { out.push(norm(o.value)); });
    return out;
  }

  function stitchGroup(root) {
    var found = null;
    fieldsets(root).forEach(function (fs) {
      var v = valuesOf(fs);
      if (v.indexOf('unstitched') > -1 || v.indexOf('stitched') > -1) found = fs;
    });
    return found;
  }

  function sizeGroup(root) {
    var found = null;
    fieldsets(root).forEach(function (fs) {
      var v = valuesOf(fs);
      var legend = fs.querySelector('legend, label');
      var lt = legend ? norm(legend.textContent) : '';
      if (v.indexOf('small') > -1 || v.indexOf('medium') > -1 || v.indexOf('large') > -1 || lt.indexOf('size') > -1) {
        if (v.indexOf('unstitched') === -1 && v.indexOf('stitched') === -1) found = fs;
      }
    });
    return found;
  }

  function currentStitch(root) {
    var stg = stitchGroup(root);
    if (!stg) return '';
    var checked = stg.querySelector('input[type="radio"]:checked');
    if (checked) return norm(checked.value);
    var sel = stg.querySelector('select');
    if (sel) return norm(sel.value);
    return '';
  }

  /* Visual only — safe to call on every render, never dispatches. */
  function applyLock(root) {
    var sg = sizeGroup(root);
    if (!sg) return;
    if (currentStitch(root) === 'unstitched') sg.classList.add('iris-size-locked');
    else sg.classList.remove('iris-size-locked');
  }

  /* On a change to the Stitch Type group, if Unstitched, auto-select a valid
     size (the single "bucket" size the unstitched variant lives under) so the
     form still resolves to a real variant. Handles both a Size dropdown and
     Size pill buttons. */
  function onStitchChange(root) {
    if (currentStitch(root) !== 'unstitched') { applyLock(root); return; }
    var sg = sizeGroup(root);
    if (sg) {
      var select = sg.querySelector('select');
      if (select) {
        if (select.selectedIndex !== 0) {
          select.selectedIndex = 0; /* first size = the unstitched bucket (Small) */
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        var radios = sg.querySelectorAll('input[type="radio"]');
        var target = null;
        for (var i = 0; i < radios.length; i++) {
          if (!radios[i].classList.contains('disabled')) { target = radios[i]; break; }
        }
        if (!target && radios.length) target = radios[0];
        if (target && !target.checked) {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    applyLock(root);
  }

  document.addEventListener('change', function (e) {
    var root = e.target.closest ? e.target.closest('variant-selects') : null;
    if (!root) return;
    var stg = stitchGroup(root);
    if (stg && stg.contains(e.target)) onStitchChange(root);
    else applyLock(root);
  });

  function init() {
    document.querySelectorAll('variant-selects').forEach(function (root) {
      applyLock(root);
      new MutationObserver(function () { applyLock(root); })
        .observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
